export default __webpack_public_path__ + "static/media/appStore.efcc65fb.png";